import React from 'react';

interface DropdownProps<T extends string> {
  label: string;
  options: T[];
  selectedValue: T;
  onValueChange: (value: T) => void;
  id: string;
}

export const Dropdown = <T extends string>({
  label,
  options,
  selectedValue,
  onValueChange,
  id,
}: DropdownProps<T>) => {
  return (
   <div className="flex flex-col mb-4">
  {/* fixed-height label row to align grid */}
  <div className="h-6 flex items-end">
    <label
      htmlFor={id}
      className="block text-base font-bold text-gray-600 leading-5"
    >
      {label}
    </label>
  </div>

  <select
    id={id}
    value={selectedValue}
    onChange={(e) => onValueChange(e.target.value as T)}
    className="mt-1 block w-full py-3 px-3.5 bg-white text-gray-600 text-base font-semibold border-2 border-gray-600 rounded-xl shadow-sm focus:outline-none focus:border-brand-orange focus:ring-[3px] focus:ring-[#F75C03]/25"
  >
    {options.map((option) => (
      <option key={option} value={option} className="font-semibold text-gray-600">
        {option}
      </option>
    ))}
  </select>
</div>

  );
};